<template>
    <div class="question-date-type">
        <div v-if="hasError">
            <b-alert show variant="danger">{{ errorText }}</b-alert>
        </div>
        <b-form-group
            id="custom-form-question-date"
            label-for="custom-form-question-date">
            <template v-slot:label>
                {{ questionIn.text }}: <span class="required" v-if="questionIn.required">*</span>
            </template>
            <b-form-datepicker
                :value="value"
                :config="dateConfig"
                start-weekday="1"
                now-button
                reset-button
                right
                today-variant="primary"
                nav-button-variant="primary"
                locale="nl"
                aria-controls="Kies een datum"
                label-reset-button="reset"
                label-no-date-selected="Geen datum geselecteerd"
                class="apprentice-date-picker btn-date-group"
                menu-class="datedropdown"
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                @input="update">
            </b-form-datepicker>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "custom-form-create-question-date-component",
    props: {
        questionIn: {
            type: Object,
            required: true,
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorText: {
            type: String,
            required: false,
            default: 'Deze vraag is verplicht.'
        },
        value: {
            type: String,
        }
    },
    data() {
        return  {
            dateConfig: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
            }
        }
    },
    methods:{
        update(date){
            this.$emit('update-answer', {
                questionId: this.questionIn.id,
                value: date,
                isEmpty: !date,
                type: 2
            });
        }
    }
}
</script>

<style scoped>

</style>
